import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import WmsSidebar from '../../components/WmsSidebar';
import WmsTopbar from '../../components/wms_topbar';
import { putawayFlows } from '../../flows/putawayFlows';
import { pickingFlows } from '../../flows/pickingFlows';
import WidgetsIcon from '@mui/icons-material/Widgets';

const putawayIcons = {
  'putaway-pieza': <span className="pi pi-box text-blue-600 bg-blue-100 rounded-full p-2 text-3xl mb-2 shadow-sm" />,
  'putaway-hu': <WidgetsIcon className="text-green-700 bg-green-100 rounded-full p-2 text-3xl mb-2 shadow-sm" style={{ fontSize: 38 }} />,
};

const almacenajeFlows = [
  ...putawayFlows,
  ...pickingFlows
];

const WmsAlmacenaje = () => {
  const [activeItem, setActiveItem] = useState('almacenaje');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleStartFlow = (flowKey) => {
    navigate(`/wms/almacenaje/flow/${flowKey}`);
  };

  return (
    <div className="flex">
      {/* Sidebar drawer solo en móvil */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
      <div
        className={`fixed z-50 inset-y-0 left-0 transition-transform duration-300 md:hidden ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ width: '256px', minHeight: '100vh' }}
      >
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      {/* Sidebar estático solo en desktop, en el flujo normal */}
      <div className="hidden md:flex">
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      <div className="flex-1 bg-gray-100 min-h-screen md:p-6">
        <WmsTopbar rightContent={
          <button
            className="md:hidden p-2 ml-2"
            onClick={() => setSidebarOpen(true)}
            aria-label="Abrir menú"
            style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}
          >
            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="25" y2="12"/><line x1="3" y1="6" x2="25" y2="6"/><line x1="3" y1="18" x2="25" y2="18"/></svg>
          </button>
        } />
        <h1 className="text-2xl font-bold mb-2 text-center">Almacenaje y Put Away</h1>
        <p className="mb-6 text-center text-gray-700">Colocación física de mercancía desde staging a ubicaciones finales.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
          {almacenajeFlows.map(opt => (
            <button
              key={opt.key}
              className="flex flex-col items-center justify-center bg-white border border-gray-200 hover:border-blue-400 hover:shadow-lg text-gray-800 rounded-xl p-4 shadow transition text-center focus:outline-none focus:ring-2 focus:ring-blue-300 group"
              onClick={() => handleStartFlow(opt.key)}
            >
              {putawayIcons[opt.key] || <span className="pi pi-list-check text-orange-600 bg-orange-100 rounded-full p-2 text-3xl mb-2 shadow-sm" />} 
              <span className="font-semibold text-sm leading-tight group-hover:text-blue-700 transition-colors">{opt.label}</span>
              <span className="text-[11px] text-gray-500 font-normal mt-1 group-hover:text-blue-500 transition-colors">{opt.description}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WmsAlmacenaje;
